import { usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { useLoginState } from '#src/app/shared/hooks/session';

/**
 * @param addressPredicate - whether the current user's address fields meet the caller's criteria
 */
export function useAddressFieldForAuthenticated(addressPredicate: boolean): Result {
	const {
		data: { fullAddressCollectionEnabled },
	} = usePetitionDetailsPageUserData();

	const loginState = useLoginState();

	return {
		data: {
			enabled: loginState === 'AUTHENTICATED' && addressPredicate && fullAddressCollectionEnabled,
		},
	};
}

type Result = ModelHookResult<{
	enabled: boolean;
}>;
